// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "canvas[data-v-68ac97ff]{max-width:200px}", ""]);
// Exports
module.exports = exports;
